<template>
  <div>
    <div v-if="auxNode">
      <h4>Details for {{auxNode.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{auxNode[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="auxNode.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "auxNode",
  components: {
    BFR
  },
  props: {
    auxNode: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["modelNo", "Model Number"],
      ["voltageRating", "Voltage Rating"],
      ["ampRating", "Amp Rating"],
      ["notes", "Notes"],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
